import bulkPriceUpdate from './bulkPriceUpdate';

export default {
  bulkPriceUpdate,
};



// WEBPACK FOOTER //
// ./src/app/services/advance/index.js